import styled, { css } from "styled-components";

export const BackgroundContainer = styled.div<{
  backgroundColor?: string;
  scrollEnabled?: boolean;
}>`
  min-width: 100%;
  min-height: 100%;
  padding: ${({ theme }) =>
    theme.isMobile
      ? `${theme.getValue(48)}px 0 0`
      : `${theme.getValue(100)}px 0 0`};
  background: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.colors.green4};

  ${({ scrollEnabled }) =>
    scrollEnabled === false
      ? css`
          max-height: 100%;
          overflow: hidden;
        `
      : ""}
`;

export const Container = styled.div`
  font-family: "HarmoniaSansStd", Arial;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;

  max-width: ${({ theme }) => theme.getValue(1560)}px;
  margin: 0 auto;
  padding: ${({ theme }) =>
    theme.isMobile ? `0 ${theme.getValue(8)}px` : `0 ${theme.getValue(100)}px`};

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
      monospace;
  }

  .sr-only:not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
